export default __webpack_public_path__ + "static/media/Poppins-Thin.21c849b9.woff2";